'use client'

import { exists } from '../../../../MyStichtingOpenHelpers/src/static'

export const SEARCH_INVOKED_EVENT = 'stopen-search-invoked' as const

type SearchInvokedDetail = {
    searchTerm: string
}

export const dispatchSearchInvoked = (searchTerm: string): void => {
    if (!exists(searchTerm) || searchTerm === '') return
    document.dispatchEvent(new CustomEvent<SearchInvokedDetail>(SEARCH_INVOKED_EVENT, { detail: { searchTerm } }))
}
